<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-info"></i> Detalle de Devolución de Contrato {{loan.contractNumber}}
      <div class="card-header-actions btn-group" dropdown placement="bottom left">
        <button type="button" (click)="print()" class="btn btn-sm btn-outline-success"><i
            class="fa fa-regular fa-file"></i>&nbsp;Imprimir Documentos</button>
      </div>
    </div>
    <div class="card-body">
      <accordion [isAnimated]="true">
        <accordion-group [isOpen]="true">
          <span accordion-heading>
            <i class='fa fa-users'></i> Información General
          </span>
          <div class="form-group row">
            <label class="col-md-3 col-form-label"><b>Cliente</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control" disabled
                [(ngModel)]="customerInformation">
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Creada Por</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="sellerInformation"
                disabled>
            </div>
          </div> -->
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Numero de Contracto</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control"
                [(ngModel)]="loan.contractNumber" disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="text-input"><b>Fecha de Creacion</b></label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="createdDate"
                disabled>
            </div>
          </div>
        </accordion-group>
        <accordion-group [isOpen]="true">
          <span accordion-heading>
            <i class='fa fa-regular fa-file-lines'></i> Contratos a Devolver
          </span>
          <pos-table tableFormId="loanTable" [data]="loans" [headers]="getLoanHeaders()" [itemsPerPage]="10"
            [pagination]="false" [disableHighlight]="true">
          </pos-table>
        </accordion-group>



      </accordion>
    </div>

  </div>
</div>